document.addEventListener("DOMContentLoaded", function () {

    const popup = document.getElementById("language-popup-overlay");

    if (!popup) return;

    // Current path
    const path = window.location.pathname;

    // Detect current language from URL
    let currentLanguage = "de";

    if (path.startsWith("/tr")) {
        currentLanguage = "tr";
    } else if (path.startsWith("/en")) {
        currentLanguage = "en";
    }

    // Save language automatically if user visits /tr or /en
    localStorage.setItem("preferred_language", currentLanguage);

    // Don't show popup if language already selected
    if (localStorage.getItem("language_popup_seen") === "1") {
        return;
    }

    // Show popup
    popup.style.display = "flex";

    document.querySelectorAll(".language-btn").forEach(button => {

        button.addEventListener("click", function () {

            let language = "de";

            if (this.getAttribute("href").startsWith("/tr")) {
                language = "tr";
            }

            if (this.getAttribute("href").startsWith("/en")) {
                language = "en";
            }

            localStorage.setItem("preferred_language", language);
            localStorage.setItem("language_popup_seen", "1");

        });

    });

});